module.exports = __webpack_public_path__ + "coupon-code-white.svg?3279504841557334b15301e20137cae4";